export default __webpack_public_path__ + "static/media/logo.697dc1af.svg";